import React from 'react'
import { Outlet } from 'react-router-dom'
import { AnalyticsProvider } from '@keiko-app/react-google-analytics'
import { TabsLayout } from '@/components/TabsLayout'
import ScrollToTop from '@/components/ScrollToTop'
import { RouteTracker } from '@/components/RouteTracker'
import PageviewAnalyticsWrapper from '../PageviewAnalyticsWrapper'
import { FirebaseAuthRedirectHandler } from '@/components/app-effects/FirebaseAuthRedirectHandler'

export const AppLayout: React.FC = () => {
  const analyticsConfig = {
    measurementId: 'G-ZG2M2L2VBD',
  }

  return (
    <AnalyticsProvider config={analyticsConfig}>
      <PageviewAnalyticsWrapper>
        <TabsLayout>
          <FirebaseAuthRedirectHandler />
          <RouteTracker />
          <ScrollToTop />
          <Outlet />
        </TabsLayout>
      </PageviewAnalyticsWrapper>
    </AnalyticsProvider>
  )
}
